
import * as yup from 'yup';

var currentYear = new Date().getFullYear();
const phoneNumberNotEmptySchema = yup.string()
  .min(5, 'Phone number must have minimum 5 characters.')
  .max(30, 'Phone number must have maximum 30 characters.');

// Define schema when phoneNumber1 is empty or null
const phoneNumberEmptySchema = yup.string().nullable();
const InitialprofileSchema = yup.object().shape({
  Yearestablishment: yup.number().required('Please Enter Year').min(1830, 'Year Must be minimum 1830 ').max(currentYear, `year Must be less than or equal to ${currentYear}`).typeError('Please Enter Year'),
  startup: yup.string(),
  CRN: yup.string().required('Please Enter Company Registration Number').
    min(3, 'Company Registration number must have minimum 3 characters.').max(70, 'Company Registration number must have maximum 70 Characters.'), //matches(/^[a-z0-9]+$/i, 'only Alphanumeric characters are allowed.').
  isVat: yup.string(),
  // VATN : yup.string().matches(/^$|^[a-zA-Z0-9]+$/i, 'only Alphanumeric characters are allowed.').max(70, 'Company Registration number must have maximum 70 Characters.').nullable(),
  VATN: yup.string().when(
    "isVat", {
    is: '1',
    then: yup.string().required('Please Enter VAT Number').min(3, 'VAT number must have minimum 3 characters.').
      matches(/^[a-z0-9]+$/i, 'only Alphanumeric characters are allowed.').max(70, 'Company Registration number must have maximum 70 Characters.'),
  }
  ),
  productBrand: yup.object().when("typeId", {
    is: '2', then: yup.object().when(
      "startup", {
      is: '1',
      then: yup.object().shape({
        id: yup.number().required(),
        name: yup.string().required()
      }).required('Please Select a Product Brand').nullable()
    })
  }),

  multiProductBrand: yup.array().when("typeId", {
    is: '3' || '4', then: yup.array().of(yup.object().when(
      "startup", {
      is: '1',
      then: yup.object().shape({
        id: yup.number().required(),
        name: yup.string().required()
      }).required('Please Select a Product Brand').nullable()
    }))
  }),



  Brands: yup.object().when("typeId", {
    is: '2' || '3',
    then: yup.object().shape({
      id: yup.number(),
      name: yup.string().required(),
      doc_id: yup.string(),
      documentpath: yup.string(),
      isNew: yup.string(),
    }).required('Choose a Brand').nullable()
  }),
  brandList: yup.string().when("typeId", { is: '2', then: yup.string().required('Please Choose a Brand') }),

  // ProductGroup:yup.array().when("typeId",{is:'3',then:yup.array().of(yup.object().shape({
  //   firstLetter: yup.string().required(),
  //   groupid: yup.string().required(),
  //   groupname: yup.string().required(),
  //   childid: yup.string().required(),
  //   childname: yup.string().required(),
  // })).required('Please Select a Product Family')}),

  // relevantProfiles:yup.array().when("typeId",{is:'4',then:yup.array().of(yup.object().shape({
  //   firstLetter: yup.string().required(),
  //   //groupid: yup.string().required(),
  //   groupname: yup.string().required(),
  //   childid: yup.string().required(),
  //   childname: yup.string().required(),
  // })).required('Please Select Channel Profile')}),
  relevantChannelProfiles: yup.string().when("typeId", { is: (typeId) => (typeId == '2') || (typeId == '3'), then: yup.string().required('Please Select Channel Profile') }),
  // relevantChannelProfiles:yup.string().when("typeId",{is:'3',then:yup.string().required('Please Select Channel Profile')}),
  productCat: yup.string().when("typeId", { is: '3', then: yup.string().when("productVal", { is: (val) => (val != 'broadliner'), then: yup.string().required('Please Select a Product Family') }) }),

  relevantRetailerProfiles: yup.object().when("typeId", {
    is: '4', then: yup.object().shape({
      firstLetter: yup.string().required(),
      //groupid: yup.string().required(),
      groupname: yup.string().required(),
      childid: yup.string().required(),
      childname: yup.string().required(),

    }).required('Please Select Channel Profile')
  }),


  DistributorProfiles: yup.object().when("typeId", {
    is: '3', then: yup.object().shape({
      firstLetter: yup.string().required(),
      //groupid: yup.string().required(),
      groupname: yup.string().required(),
      childid: yup.string().required(),
      childname: yup.string().required(),
    }).required('Please Select Distributor Profile')
  }),

  no_of_staffs: yup.string().required('Select No.of.Staffs'),
  annualTurnOver: yup.string().required('Select Annual Turnover'),
  tweetPitch: yup.string().required("TweetPitch can't be empty!").min(5, 'TweetPitch must have min 5 Characters').max(280, 'TweetPitch must have max 280 Characters'),
  //companyDescription: yup.string().required("Company Description can't be empty!").min(5, 'Company Description must have min 5 Characters').max(2000, 'Company Description must have max 2000 Characters'),
  //tradeCompanyDescription: yup.string().required("Trade Description can't be empty!").min(5, 'Trade Description must have min 5 Characters').max(2000, 'Trade Description must have max 2000 Characters'),
  no_of_skus: yup.number().when("typeId", { is: 2 || 3, then: yup.number().required('Please Enter No of SKU').min(0, 'Sku must have min 0').max(9999, 'sku must have max 4 digits').typeError('Please Enter No of SKU') }).typeError('Please Enter No of SKU'),
  companyLogo: yup.string().required('Please Select companyLogo'),

  tradeUrls: yup.array().of(yup.object({
    value: yup.lazy(value => !value ? yup.string() : yup.string()
      .matches(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,63}(:[0-9]{1,63})?(\/.*)?$/, 'Please Enter Valid Url.'))
  })),
  insta: yup.lazy(value => !value ? yup.string() : yup.string().matches(/^(?=[a-zA-Z0-9._-]{0,30}$)(?!.*[_.-]{2})[^_.-].*[^_.-]$/, 'Instagram url can have 0-30 characters.')),
  // .matches(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/, 'Please Enter Valid Url.')),
  twitter: yup.lazy(value => !value ? yup.string() : yup.string().matches(/^(?=[a-zA-Z0-9._-]{0,15}$)(?!.*[_.-]{2})[^_.-].*[^_.-]$/, 'Twitter url can have 0-15 characters.')),
  // .matches(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/, 'Please Enter Valid Url.')),
  facebook: yup.lazy(value => !value ? yup.string() : yup.string().matches(/^(?=[a-zA-Z0-9._-]{0,50}$)(?!.*[_.-]{2})[^_.-].*[^_.-]$/, 'Facebook url can have 0-50 characters.')),
  // .matches(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/, 'Please Enter Valid Url.')),
  linkedIn: yup.lazy(value => !value ? yup.string() : yup.string().matches(/^(?=[a-zA-Z0-9._-]{0,100}$)(?!.*[_.-]{2})[^_.-].*[^_.-]$/, 'LinkedIn url can have 0-100 characters.')),

});

const AddFirstProductSchema = yup.object().shape({
  proname: yup.string().required('Enter Product Name').min(3, 'Product Name must have Min 3 Characters').max(255, 'Product Name must have Max 255 Characters'),
  availability: yup.string(),
  noLimit: yup.boolean(),
  // productVisibility : yup.string().required('Please Choose visibility'),
  ProductCategory: yup.object().shape({
    id: yup.number().required(),
    name: yup.string().required(),
    groupid: yup.string().required(),
  }).required('Choose Product Category').nullable(),
  ProductBrand: yup.object().shape({
    id: yup.number().required(),
    name: yup.string().required()
  }).required('Choose Product Brand').nullable(),

  // awards:yup.object().shape({
  //     id: yup.number().required(),
  //     name: yup.string().required()
  //   }).required('Choose awards').nullable(),
  videoUrl: yup.string().matches(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/, 'Please Enter Valid Url.').transform(value => !value ? null : value).nullable(), //.required('Please provide video Url.')
  tweetPitch: yup.string().required("TweetPitch can't be empty!").min(5, 'TweetPitch must have min 5 Characters').max(140, 'TweetPitch must have max 140 Characters'),
  productshortdec: yup.string().required("product Description can't be empty!").min(5, 'product Description must have min 5 Characters').max(75, 'product Description must have max 75 Characters'),
  productCertification: yup.string().max(255, 'Product Certification must have max 255 Characters'), //.required("Product Certification can't be empty!").min(5, 'Product Certification must have min 5 Characters')
  productWarranty: yup.string().max(255, 'Product Warranty must have max 255 Characters'), //.required("Product Warranty can't be empty!").min(5, 'Product Warranty must have min 5 Characters')
  productLocalisation: yup.string().max(255, 'Product Localisation must have max 255 Characters'), //.required("Product Localisation can't be empty!").min(5, 'Product Localisation must have min 5 Characters')
  // date: yup.string().when("availability", {
  //   is: 'Available From',
  //   then: yup.string().required('')
  //   }).required('Please Select a Date').nullable(),
  msrp: yup.string().required('Please enter MSRP.'),
  moq: yup.string().required('Please enter MOQ.'),
  unit: yup.string().required('Please select unit.'),
  busCurrency: yup.string().required('Please select Business Currency.'),
  moqUnit: yup.string().required('Please select unit.'),
  max_qty_sample: yup.string().when("noLimit", {
    is: false,
    then: yup.string().required('Please enter Maximum Qty for Sample Orders.')
  }),
  date: yup.date().when('availability', {
    is: 'Available From',
    then: yup.date().required('Please Enter the Date.').typeError('Please Enter Valid Date.'),
  })
});

const UserProfileSchema = yup.object().shape({

  selling: yup.string().when("typeId", { is: (typeId) => (typeId == 4 || typeId == 3), then: yup.string().required('Please Choose Selling Locations') }),
  target: yup.string().when("typeId", { is: (typeId) => (typeId == 2 || typeId == 3), then: yup.string().required('Please Choose Target Locations') }),


  productCat: yup.string().required('Please Select a Product'),

  CommunicationPreference1: yup.string().required('Please Select Communication Preference 1'),
  CommunicationPreference2: yup.string().required('Please Select Communication Preference 2'),
  companyLogo: yup.string().required('Please Select Profile Image.'),
});


const companyProfileSchema = yup.object().shape({
  Yearestablishment: yup.number().required('Please Enter Year').min(1830, 'Year Must be minimum 1830 ').max(currentYear, `year Must be less than or equal to ${currentYear}`).typeError('Please Enter Year'),
  companyLogo: yup.string().required('Please Select companyLogo'),
  companyName: yup.string().required('Please Enter Company Legal Name'),
 // metaTags: yup.string().required('Please Enter Company Meta Tags').matches(/^[a-zA-Z,]+$/, 'Meta Tags allows Only alphabets (both uppercase and lowercase) and commas'),
  customUrl: yup.string().required('Please Enter Custom URL').matches(/^[a-zA-Z0-9_ ]+$/, 'Custom URL  allows Only alphabets (both uppercase and lowercase) , space, underscore'), 
  country: yup.string().required('Please Select Your country'),
  zipCode: yup.string().required('Please Enter Zip/Postal Code').min(3, 'Zip/Postal Code Must Have Min 3 Characters').max(12, 'Zip/Postal Code Must Have Max 12 Characters'),
  websiteUrl: yup.string().required('Please Enter Company Website URL').matches(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,63}(:[0-9]{1,63})?(\/.*)?$/, 'Please Enter Valid Url.'),
  tweetPitch: yup.string().required("TweetPitch can't be empty!").min(5, 'TweetPitch must have min 5 Characters').max(280, 'TweetPitch must have max 280 Characters'),
  sourcing: yup.string().when("typeId", { is: (typeId) => (typeId != '2'), then: yup.string().min(5, 'Sourcing Priority & Strategy must have min 5 Characters').max(5000, 'Sourcing Priority & Strategy must have max 5000 Characters') }),
  companyDesc: yup.string().min(5, 'Company Description must have min 5 Characters').max(2000, 'Company Description must have max 2000 Characters'),
  CRN: yup.string().required('Please Enter Company Registration Number').
    min(3, 'Company Registration number must have minimum 3 characters.').max(70, 'Company Registration number must have maximum 70 Characters.'), //matches(/^[a-z0-9]+$/i, 'only Alphanumeric characters are allowed.').
  // VATN : yup.string().matches(/^$|^[a-zA-Z0-9]+$/i, 'only Alphanumeric characters are allowed.').max(70, 'Company Registration number must have maximum 70 Characters.').nullable(),
  VATN: yup.string().when(
    "isVat", {
    is: '1',
    then: yup.string().required('Please Enter VAT Number').min(3, 'VAT number must have minimum 3 characters.').
      matches(/^[a-z0-9]+$/i, 'only Alphanumeric characters are allowed.').max(70, 'Company Registration number must have maximum 70 Characters.'),
  }
  ),
  city: yup.string().required('Please Enter Your City.'),
  phoneNumber1: yup.string()
  .test('max-length', 'The maximum length for the field is 30 characters.', function(value) {
    // Check if the value is not empty and its length exceeds 30 characters
    return !(value && value.length > 30);
  })
  .test('min-length', 'Phone number must have minimum 5 characters.', function(value) {
    // Check if the value is not empty and its length is less than 5 characters
    return !(value && value.length > 0 && value.length < 5);
  })
  .test('valid-phone', 'Please Enter a valid Phone Number', function(value) {
    // Check if the value is not empty
    if (value && value.length > 0) {
      // Validate phone number pattern
      const isValidPattern = /^(?!(.*\s){4,})[0-9+ -]*[0-9]+[0-9+ -]*$/.test(value) &&
        /^(?:(?!([0-9])\1{5,}).)*$/.test(value);
      // Validate presence of non-special characters
      const hasNonSpecialChar = !/^[!@#$%^&*()_{}\[\]:;<>,.?~\\|\="']*$/.test(value);
      // Return true if both conditions are met
      return isValidPattern && hasNonSpecialChar;
    }
    // If value is empty or null, no custom validation needed
    return true;
  })
  .nullable(),
  // phoneNumber2:yup.string().min(5,'Phone number must have minimum 5 characters.').max(30,'Phone number must have maximum 30 Characters.').transform(value => !value ? null : value).nullable(), 
  mobile: yup.string().min(5, 'Phone number must have minimum 5 characters.').max(30, 'Phone number must have maximum 30 Characters.').transform(value => !value ? null : value).nullable(),
  companyemail: yup.string().email('Please Enter a valid Email Address').transform(value => !value ? null : value).nullable(),

  insta: yup.lazy(value => !value ? yup.string() : yup.string().min(2, 'Instagram handle should have more than 2 characters').max(30, 'Instagram handle should have maximum of 30 characters')),
  // matches(/^(?=[a-zA-Z0-9._-]{0,30}$)(?!.*[_.-]{2})[^_.-].*[^_.-]$/, 'Please Enter Valid Instagram Handle')),
  // .matches(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/, 'Please Enter Valid Url.')),
  twitter: yup.lazy(value => !value ? yup.string() : yup.string().min(2, 'X handle should have more than 2 characters').max(15, 'X handle should have maximum of 15 characters')),
  // matches(/^(?=[a-zA-Z0-9._-]{0,15}$)(?!.*[_.-]{2})[^_.-].*[^_.-]$/, 'Please Enter Valid Twitter Handle')),
  // .matches(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/, 'Please Enter Valid Url.')),
  facebook: yup.lazy(value => !value ? yup.string() : yup.string().min(2, 'Facebook handle should have more than 2 characters').max(50, 'Facebook handle should have maximum of 50 characters')),
  // matches(/^(?=[a-zA-Z0-9._-]{0,50}$)(?!.*[_.-]{2})[^_.-].*[^_.-]$/, 'Please Enter Valid Facebook Handle')),
  // .matches(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/, 'Please Enter Valid Url.')),
  linkedIn: yup.lazy(value => !value ? yup.string() : yup.string().min(2, 'LinkedIn handle should have more than 2 characters').max(100, 'LinkedIn handle should have maximum of 100 characters')),
  // matches(/^(?=[a-zA-Z0-9._-]{0,100}$)(?!.*[_.-]{2})[^_.-].*[^_.-]$/, 'Please Enter Valid LinkedIn Handle')),

  tradeUrls: yup.array().of(yup.object({
    value: yup.lazy(value => !value ? yup.string() : yup.string()
      .matches(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,63}(:[0-9]{1,63})?(\/.*)?$/, 'Please Enter Valid Url.'))
  })),

  brandList: yup.string().when("typeId", { is: (typeId) => (typeId == '2' || typeId == '3'), then: yup.string().required('Please Choose a Brand') }),



  productCat: yup.string().required('Please Select a Product Family'),

  no_of_skus: yup.number().when("typeId", { is: '2', then: yup.number().required('Please Enter No of SKUs').min(0, 'Sku must have min 0').max(9999, 'sku must have max 4 digits').typeError("Please Enter No of SKUs") }).nullable(),
  // storeCount: yup.number().when("typeId",{is:'4', then:yup.number().required("Please Enter No of Store's").min(0, 'No of store must have min 0').max(9999, 'sku must have max 4 digits').typeError("Please Enter No of Store's")}).nullable(),

  // revenue: yup.number().max(100, 'The total of Domestic Revenue and International Revenue should not exceed 100%').nullable(),

  no_of_staffs: yup.string().required('Select No.of.Staffs'),
  annualTurnOver: yup.string().required('Select Annual Turnover'),
  turnOver: yup.lazy(value => !value ? yup.string() : yup.number().min(0, 'Please enter non-negative values')),
  staffCnt: yup.lazy(value => !value ? yup.string() : yup.number().min(0, 'Please enter non-negative values')),

  // profile: yup.string().when("typeId",{is:'3',then:yup.string().required('Please Select a Product Distributor Profile')
  //     }),
  // speciality: yup.string().when("typeId", {is:'3', then: yup.string().when("profile", {is: "1", then: yup.string().required('Please Select Channel Speciality')})}),

  // relevantChannelProfiles:yup.string().when("typeId", {is: (typeId) => (typeId=='2' || typeId=='3'),then: yup.string().required('Please Select Channel Profile')}),

  // relevantRetailerProfiles:yup.object().when("typeId",{is:'4',then:yup.object().shape({
  //   // firstLetter: yup.string().required(),
  //   //groupid: yup.string().required(),
  //   groupname: yup.string().required(),
  //   // childid: yup.string().required(),
  //   childname: yup.string().required(),

  // }).required('Please Select Channel Profile')}),

});


const companyDistProfileSchema = yup.object().shape({
  Yearestablishment: yup.number().required('Please Enter Year').min(1830, 'Year Must be minimum 1830 ').max(currentYear, `year Must be less than or equal to ${currentYear}`).typeError('Please Enter Year'),
  companyLogo: yup.string().required('Please Select companyLogo'),
  companyName: yup.string().required('Please Enter Company Legal Name'),
  //metaTags: yup.string().required('Please Enter Company Meta Tags').matches(/^[a-zA-Z,]+$/, 'Meta Tags allows Only alphabets (both uppercase and lowercase) and commas'),
  customUrl: yup.string().required('Please Enter Custom URL').matches(/^[a-zA-Z0-9_ ]+$/, 'Custom URL allows only alphabets (both uppercase and lowercase), space, underscore'),  
  websiteUrl: yup.string().required('Please Enter Company Website URL').matches(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,63}(:[0-9]{1,63})?(\/.*)?$/, 'Please Enter Valid Url.'),
  tweetPitch: yup.string().required("TweetPitch can't be empty!").min(5, 'TweetPitch must have min 5 Characters').max(280, 'TweetPitch must have max 280 Characters'),
  sourcing: yup.string().when("typeId", { is: (typeId) => (typeId != '2'), then: yup.string().min(5, 'Sourcing Priority & Strategy must have min 5 Characters').max(5000, 'Sourcing Priority & Strategy must have max 5000 Characters') }),
  companyDesc: yup.string().min(5, 'Company Description must have min 5 Characters').max(2000, 'Company Description must have max 2000 Characters'),
  CRN: yup.string().required('Please Enter Company Registration Number').
    min(3, 'Company Registration number must have minimum 3 characters.').max(70, 'Company Registration number must have maximum 70 Characters.'), //matches(/^[a-z0-9]+$/i, 'only Alphanumeric characters are allowed.').
  // VATN : yup.string().matches(/^$|^[a-zA-Z0-9]+$/i, 'only Alphanumeric characters are allowed.').max(70, 'Company Registration number must have maximum 70 Characters.').nullable(),
  VATN: yup.string().when(
    "isVat", {
    is: '1',
    then: yup.lazy(value => !value ? yup.string() : yup.string().min(3, 'VAT number must have minimum 3 characters.').
      matches(/^[a-z0-9]+$/i, 'only Alphanumeric characters are allowed.').max(70, 'VAT number must have maximum 70 Characters.')),
    //  yup.string().required('Please Enter VAT Number').min(3, 'VAT number must have minimum 3 characters.').
    // matches(/^[a-z0-9]+$/i, 'only Alphanumeric characters are allowed.').max(70, 'Company Registration number must have maximum 70 Characters.'),
  }
  ),

  phoneNumber1: yup.string()
  .test('max-length', 'The maximum length for the field is 30 characters.', function(value) {
    // Check if the value is not empty and its length exceeds 30 characters
    return !(value && value.length > 30);
  })
  .test('min-length', 'Phone number must have minimum 5 characters.', function(value) {
    // Check if the value is not empty and its length is less than 5 characters
    return !(value && value.length > 0 && value.length < 5);
  })
  .test('valid-phone', 'Please Enter a valid Phone Number', function(value) {
    // Check if the value is not empty
    if (value && value.length > 0) {
      // Validate phone number pattern
      const isValidPattern = /^(?!(.*\s){4,})[0-9+ -]*[0-9]+[0-9+ -]*$/.test(value) &&
        /^(?:(?!([0-9])\1{5,}).)*$/.test(value);
      // Validate presence of non-special characters
      const hasNonSpecialChar = !/^[!@#$%^&*()_{}\[\]:;<>,.?~\\|\="']*$/.test(value);
      // Return true if both conditions are met
      return isValidPattern && hasNonSpecialChar;
    }
    // If value is empty or null, no custom validation needed
    return true;
  })
  .nullable(),
  mobile: yup.string().min(5, 'Phone number must have minimum 5 characters.').max(30, 'Phone number must have maximum 30 Characters.').transform(value => !value ? null : value).nullable(),
  email: yup.string().email('Please Enter a valid Email Address').transform(value => !value ? null : value).nullable(),

  insta: yup.lazy(value => !value ? yup.string() : yup.string().min(2, 'Instagram handle should have more than 2 characters').max(30, 'Instagram handle should have maximum of 30 characters')),
  // matches(/^(?=[a-zA-Z0-9._-]{0,30}$)(?!.*[_.-]{2})[^_.-].*[^_.-]$/, 'Please Enter Valid Instagram Handle')),
  // .matches(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/, 'Please Enter Valid Url.')),
  twitter: yup.lazy(value => !value ? yup.string() : yup.string().min(2, 'X handle should have more than 2 characters').max(15, 'X handle should have maximum of 15 characters')),
  // matches(/^(?=[a-zA-Z0-9._-]{0,15}$)(?!.*[_.-]{2})[^_.-].*[^_.-]$/, 'Please Enter Valid Twitter Handle')),
  // .matches(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/, 'Please Enter Valid Url.')),
  facebook: yup.lazy(value => !value ? yup.string() : yup.string().min(2, 'Facebook handle should have more than 2 characters').max(50, 'Facebook handle should have maximum of 50 characters')),
  // matches(/^(?=[a-zA-Z0-9._-]{0,50}$)(?!.*[_.-]{2})[^_.-].*[^_.-]$/, 'Please Enter Valid Facebook Handle')),
  // .matches(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/, 'Please Enter Valid Url.')),
  linkedIn: yup.lazy(value => !value ? yup.string() : yup.string().min(2, 'LinkedIn handle should have more than 2 characters').max(100, 'LinkedIn handle should have maximum of 100 characters')),
  // matches(/^(?=[a-zA-Z0-9._-]{0,100}$)(?!.*[_.-]{2})[^_.-].*[^_.-]$/, 'Please Enter Valid LinkedIn Handle')),

  tradeUrls: yup.array().of(yup.object({
    value: yup.lazy(value => !value ? yup.string() : yup.string()
      .matches(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,63}(:[0-9]{1,63})?(\/.*)?$/, 'Please Enter Valid Url.'))
  })),

  // websiteUrl: yup.array().of(yup.object({
  //   value : yup.lazy(value => !value ? yup.string() : yup.string()
  //   .matches(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/, 'Please Enter Valid Url.'))
  // })),


  productCat: yup.string().required('Please Select a Product Family'),
  brandList: yup.string().when("typeId", { is: (typeId) => (typeId == '2' || typeId == '3'), then: yup.string().required('Please Choose a Brand') }),




  no_of_staffs: yup.string().required('Select No.of.Staffs'),
  annualTurnOver: yup.string().required('Select Annual Turnover'),
  turnOver: yup.lazy(value => !value ? yup.string() : yup.number().min(0, 'Please enter non-negative values')),
  staffCnt: yup.lazy(value => !value ? yup.string() : yup.number().min(0, 'Please enter non-negative values')),

  relevantChannelProfiles: yup.string().when("isOEM", { is: (typeId) => (typeId == '1' || typeId == '3'), then: yup.string().required('Please Select Retailer Profile') }),
  relevantResellerProfiles: yup.string().when("isOEM", { is: (typeId) => (typeId == '2' || typeId == '3'), then: yup.string().required('Please Select Reseller Profile') }),

  no_of_retailers: yup.number().when("businessType", { is: (typeId) => (typeId == '1' || typeId == '3'), then: yup.number().required('Please Enter No of Retailers').min(0, 'Retailer must have min 0').typeError('Please Enter No of Retailers') }),
  no_of_resellers: yup.number().when("businessType", { is: (typeId) => (typeId == '2' || typeId == '3'), then: yup.number().required('Please Enter No of Resellers').min(0, 'Reseller must have min 0').typeError('Please Enter No of Resellers') }),

  // no_of_resellers: yup.number().required('Please Enter No of Resellers').min(0, 'Distributor must have min 0').typeError('Please Enter No of Resellers'),
  // no_of_retailers: yup.number().required('Please Enter No of Retailers').min(0, 'Retailer must have min 0').typeError('Please Enter No of Retailers'),

  startup: yup.string(),
  productBrand: yup.string().when("startup", { is: '1', then: yup.string().required('select maturity level') }),

  DistributorProfiles: yup.string().when("typeId", { is: '3', then: yup.string().required('Please Select Channel Speciality') }),

  speciality: yup.string().when("typeId", { is: '3', then: yup.string().when("profile", { is: "1", then: yup.string().required('Please Select Channel Speciality') }) }),

  selling: yup.string().when("typeId", { is: (typeId) => (typeId == 4 || typeId == 3 || typeId == 5), then: yup.string().required('Please Choose Selling Locations') }),

});


const TradeInformationSchema = yup.object().shape({

  // profile: yup.string().when("typeId",{is:'3',then:yup.string().required('Please Select a Product Distributor Profile')
  //     }),
  // speciality: yup.string().when("typeId", {is:'3', then: yup.string().when("profile", {is: "1", then: yup.string().required('Please Select Channel Speciality')})}),
  // Brands:yup.object().when("typeId", {is: (typeId) => (typeId==2 || typeId==3 ),
  //     then:yup.object().shape({
  //     id: yup.number(),
  //     name: yup.string().required(),
  //     doc_id: yup.string(),
  //     documentpath: yup.string(),
  //     isNew: yup.string(),
  //   }).required('Choose a Brand').nullable()
  // }),

  //   Retailers:yup.object().when("startUpType", {is: (typeId) => (typeId=='S_VOLUME'),
  //     then:yup.object().shape({
  //     id: yup.number(),
  //     name: yup.string().required(),
  //     doc_id: yup.string(),
  //     documentpath: yup.string(),
  //     isNew: yup.string(),
  //   }).required('Choose a Brand').nullable()
  // }),

  // Distributor:yup.object().when("startUpType", {is: (typeId) => (typeId=='S_VOLUME'),
  //   then:yup.object().shape({
  //   id: yup.number(),
  //   name: yup.string().required(),
  //   doc_id: yup.string(),
  //   documentpath: yup.string(),
  //   isNew: yup.string(),
  // }).required('Choose Key Distributor').nullable()
  // }),
  // brandList: yup.string().when("typeId", {is: (typeId) => (typeId=='2' || typeId=='3'), then: yup.string().required('Please Choose a Brand')}),
  // retailerList:  yup.string().when("startUpType", {is: (typeId) => (typeId=='S_VOLUME'),then:yup.string().required('Please Choose a Retailer')})
  // .when("typeId", {is: '3', then: yup.string().required('select a retailer (typeId3)')}),
  // DistributorList:  yup.string().when("startUpType", {is: (typeId) => (typeId=='S_VOLUME'),then:yup.string().required('Please Choose a Distributor')}),


  // relevantChannelProfiles:yup.string().when("typeId", {is: (typeId) => (typeId=='2' || typeId=='3'),then: yup.string().required('Please Select Channel Profile')}),
  // productCat:yup.string().required('Please Select a Product Family'),

  // DistributorProfiles:yup.object().when("typeId",{is:'2',then:yup.object().shape({
  //     firstLetter: yup.string().required(),
  //     //groupid: yup.string().required(),
  //     groupname: yup.string().required(),
  //     childid: yup.string().required(),
  //     childname: yup.string().required(),
  //   }).required('Please Select Distributor Profile')
  // }),

  // relevantRetailerProfiles:yup.object().when("typeId",{is:'4',then:yup.object().shape({
  //   // firstLetter: yup.string().required(),
  //   //groupid: yup.string().required(),
  //   groupname: yup.string().required(),
  //   // childid: yup.string().required(),
  //   childname: yup.string().required(),

  // }).required('Please Select Channel Profile')}),

  startUpType: yup.string().when('areYouStartUp', { is: '1', then: yup.string().required('Please Choose Maturity Level') }),
  // no_of_staffs: yup.string().required('Select No.of.Staffs'),
  // annualTurnOver: yup.string().required('Select Annual Turnover'),

  // no_of_skus: yup.number().when("typeId",{is:'2', then:yup.number().required('Please Enter No of SKUs').min(0, 'Sku must have min 0').max(9999, 'sku must have max 4 digits').typeError("Please Enter No of SKUs")}),
  // storeCount: yup.number().when("typeId",{is:'4', then:yup.number().required("Please Enter No of Store's").min(0, 'No of store must have min 0').max(9999, 'sku must have max 4 digits').typeError("Please Enter No of Store's")}),

  no_of_retailers: yup.number().when("startUpType", { is: (typeId) => (typeId == 'S_VOLUME'), then: yup.number().required('Please Enter No of Retailers').min(0, 'Retailer must have min 0').typeError('Please Enter No of Retailers') }),
  no_of_distributors: yup.number().when("startUpType", { is: (typeId) => (typeId == 'S_VOLUME'), then: yup.number().required('Please Enter No of Distributors').min(0, 'Distributor must have min 0').typeError('Please Enter No of Distributors') }),
  // revenue: yup.number().max(100, 'The total of Domestic Revenue and International Revenue should not exceed 100%').nullable(),
  selling: yup.string().when("locationType", { is: 'SELLING', then: yup.string().required('Please Choose Selling Locations') }),
  target: yup.string().when("locationType", { is: 'TARGET', then: yup.string().required('Please Choose Target Locations') }),

});

const TradeLocationSchema = yup.object().shape({
  selling: yup.string().when("locationType", { is: 'SELLING', then: yup.string().required('Please Choose Selling Locations') }),
  target: yup.string().when("locationType", { is: 'TARGET', then: yup.string().required('Please Choose Target Locations') }),
});

const AddProductSchema = yup.object().shape({
  proname: yup.string().required('Enter Product Name').min(3, 'Product Name must have Min 3 Characters').max(255, 'Product Name must have Max 255 Characters'),
  availability: yup.string(),
  noLimit: yup.boolean(),
  ProductCategory: yup.object().shape({
    id: yup.number().required(),
    name: yup.string().required(),
    groupid: yup.string().required(),
  }).required('Choose Product Category').nullable(),
  ProductBrand: yup.object().shape({
    id: yup.number().required(),
    name: yup.string().required()
  }).required('Choose Product Brand').nullable(),
  videoUrl: yup.string().matches(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/, 'Please Enter Valid Url.').transform(value => !value ? null : value).nullable(), //.required('Please provide video Url.')
  tweetPitch: yup.string().required("TweetPitch can't be empty!").min(5, 'TweetPitch must have min 5 Characters').max(280, 'TweetPitch must have max 280 Characters'),
  // productDescription: yup.string().required("product Description can't be empty!").min(5, 'product Description must have min 5 Characters').max(8000, 'product Description must have max 8000 Characters'),
  productshortdec: yup.string().required("product Short Description can't be empty!").min(5, 'product Short Description must have min 5 Characters').max(140, 'product Short Description must have max 140 Characters'),
  productCertification: yup.string().max(255, 'Product Certification must have max 255 Characters'), //.required("Product Certification can't be empty!").min(5, 'Product Certification must have min 5 Characters')
  productWarranty: yup.string().max(255, 'Product Warranty must have max 255 Characters'), //.required("Product Warranty can't be empty!").min(5, 'Product Warranty must have min 5 Characters')
  productLocalisation: yup.string().max(255, 'Product Localisation must have max 255 Characters'), //.required("Product Localisation can't be empty!").min(5, 'Product Localisation must have min 5 Characters')
  review: yup.array().of(
    yup.object().shape({
      id: yup.string(),
      articleurl: yup.string().matches(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/, 'Please Enter Valid Url.').transform(value => !value ? null : value).nullable().max( 255, 'Article url should not exceed 255 characters' ),
      reviewername: yup.string(),
      logo: yup.string()
    })
  ),

  // reviewername: yup.string().when('articleurl',{is: (value)=>value, then: yup.string().required('Please Enter Publication name')}),
  // articleurl: yup.string().when('reviewername',{is: (value)=>value, then: yup.string().required('Please Enter Article Url').matches(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/, 'Please Enter Valid Url.')}),

  // ratingproofvalidationname: yup.string().when('ratingproofvalidationurl', {is: (value)=>value, then: yup.string().required('Please Enter Rating Site name'), otherwise: yup.string()}),
  // ratingproofvalidationurl: yup.string().when('ratingproofvalidationname', {is: (value)=>value, then: yup.string().required('Please Enter Rating Url').matches(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/, 'Please Enter Valid Url.'), otherwise: yup.string()}),
  productexistingrating: yup.array().of(
    yup.object().shape({
      id: yup.string(),
      existproductrating: yup.string(),
      // .required('Please select rating')
      ratingproofvalidationurl: yup.string().matches(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/, 'Please Enter Valid Url.').transform(value => !value ? null : value).nullable(),
      ratingproofvalidationname: yup.string(),
      ratingproofvalidationlogo: yup.string()
    })
  ),

  msrp: yup.string().required('Please enter MSRP.').matches(/^[0-9]{1,}([,.][0-9]{1,10})?$/, "Please Enter Valid Price"), //typeError('MSRP must be a number'),
  moq: yup.string().required('Please enter MOQ.'),
  // unit: yup.string().required('Please select unit.'),
  busCurrency: yup.string().required('Please select Business Currency.'),
  moqUnit: yup.string().required('Please select unit.'),
  max_qty_sample: yup.string().when("no_limit", {
    is: false,
    then: yup.string().required('Please enter Maximum Qty for Sample Orders.')
  }),
  productType: yup.string().required('Please Select Product Type'),
  date: yup.date().when('availability', {
    is: 'Available From',
    then: yup.date().required('Please Enter the Date.').typeError('Please Enter Valid Date.'),
  }),
  variantDetails: yup.string().when("productAttributes", { is: '1', then: yup.string().required('Please Enter Product Variant Details.') }),
  availableFromText: yup.string().when("availability", { is: 'Available From', then: yup.string().required('Please Enter available details') }),

}, [['reviewername', 'articleurl'], ['ratingproofvalidationname', 'ratingproofvalidationurl']]);

const ProductTradeDetailsSchema = yup.object().shape({
  msrp: yup.string().required('Please enter MSRP.'),
  moq: yup.string().required('Please enter MOQ.'),
  unit: yup.string().required('Please select unit.'),
  busCurrency: yup.string().required('Please select Business Currency.'),
  moqUnit: yup.string().required('Please select unit.'),
  max_qty_sample: yup.string().when("no_limit", {
    is: false,
    then: yup.string().required('Please enter Maximum Qty for Sample Orders.')
  }),
  date: yup.date().when('availability', {
    is: 'Available From',
    then: yup.date().required('Please Enter the Date.').typeError('Please Enter Valid Date.'),
  })
});
const PostYourBuyingNeed = yup.object().shape({
  Categories: yup.string().required('Please Select a Product Category'),
  note: yup.string()
});

const companyProfileBasiEditSchema = yup.object().shape({
  companyLogo: yup.string().required('Please Select companyLogo'),
  companyName: yup.string().required('Please Enter Company Legal Name'),
  country: yup.string().required('Please Select Your country'),
  zipCode: yup.string().required('Please Enter Zip/Postal Code').min(3, 'Zip/Postal Code Must Have Min 3 Characters').max(12, 'Zip/Postal Code Must Have Max 12 Characters'),
  websiteUrl: yup.string().required('Please Enter Company Website URL').matches(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,63}(:[0-9]{1,63})?(\/.*)?$/, 'Please Enter Valid Url.'),
  tweetPitch: yup.string().required("TweetPitch can't be empty!").min(5, 'TweetPitch must have min 5 Characters').max(280, 'TweetPitch must have max 280 Characters'),
  city: yup.string().required('Please Enter Your City.'),
  phoneNumber1: yup.string()
  .test('max-length', 'The maximum length for the field is 30 characters.', function(value) {
    // Check if the value is not empty and its length exceeds 30 characters
    return !(value && value.length > 30);
  })
  .test('min-length', 'Phone number must have minimum 5 characters.', function(value) {
    // Check if the value is not empty and its length is less than 5 characters
    return !(value && value.length > 0 && value.length < 5);
  })
  .test('valid-phone', 'Please Enter a valid Phone Number', function(value) {
    // Check if the value is not empty
    if (value && value.length > 0) {
      // Validate phone number pattern
      const isValidPattern = /^(?!(.*\s){4,})[0-9+ -]*[0-9]+[0-9+ -]*$/.test(value) &&
        /^(?:(?!([0-9])\1{5,}).)*$/.test(value);
      // Validate presence of non-special characters
      const hasNonSpecialChar = !/^[!@#$%^&*()_{}\[\]:;<>,.?~\\|\="']*$/.test(value);
      // Return true if both conditions are met
      return isValidPattern && hasNonSpecialChar;
    }
    // If value is empty or null, no custom validation needed
    return true;
  })
  .nullable(),
   phoneNumber2: yup.string().min(5, 'Phone number must have minimum 5 characters.').max(30, 'Phone number must have maximum 30 Characters.').transform(value => !value ? null : value).nullable(),
  mobile: yup.string().min(5, 'Phone number must have minimum 5 characters.').max(30, 'Phone number must have maximum 30 Characters.').transform(value => !value ? null : value).nullable(),
  companyemail: yup.string().required('Please Enter Email Address').email('Please Enter a valid Email Address').transform(value => !value ? null : value).nullable(),

  // insta: yup.lazy(value => !value ? yup.string() : yup.string()
  // .matches(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/, 'Please Enter Valid Url.')),
  // linkedIn: yup.lazy(value => !value ? yup.string() : yup.string()
  // .matches(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/, 'Please Enter Valid Url.')),

  insta: yup.lazy(value => !value ? yup.string() : yup.string().min(2, 'Instagram handle should have more than 2 characters').max(30, 'Instagram handle should have maximum of 30 characters')),
  // matches(/^(?=[a-zA-Z0-9._-]{0,30}$)(?!.*[_.-]{2})[^_.-].*[^_.-]$/, 'Please Enter Valid Instagram Handle')),
  // .matches(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/, 'Please Enter Valid Url.')),
  twitter: yup.lazy(value => !value ? yup.string() : yup.string().min(2, 'X handle should have more than 2 characters').max(15, 'X handle should have maximum of 15 characters')),
  // matches(/^(?=[a-zA-Z0-9._-]{0,15}$)(?!.*[_.-]{2})[^_.-].*[^_.-]$/, 'Please Enter Valid Twitter Handle')),
  // .matches(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/, 'Please Enter Valid Url.')),
  facebook: yup.lazy(value => !value ? yup.string() : yup.string().min(2, 'Facebook handle should have more than 2 characters').max(50, 'Facebook handle should have maximum of 50 characters')),
  // matches(/^(?=[a-zA-Z0-9._-]{0,50}$)(?!.*[_.-]{2})[^_.-].*[^_.-]$/, 'Please Enter Valid Facebook Handle')),
  // .matches(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/, 'Please Enter Valid Url.')),
  linkedIn: yup.lazy(value => !value ? yup.string() : yup.string().min(2, 'LinkedIn handle should have more than 2 characters').max(100, 'LinkedIn handle should have maximum of 100 characters')),
  // matches(/^(?=[a-zA-Z0-9._-]{0,100}$)(?!.*[_.-]{2})[^_.-].*[^_.-]$/, 'Please Enter Valid LinkedIn Handle')),


  tradeUrls: yup.array().of(yup.object({
    value: yup.lazy(value => !value ? yup.string() : yup.string()
      .matches(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,63}(:[0-9]{1,63})?(\/.*)?$/, 'Please Enter Valid Url.'))
  })),
});

const profileEditSchema = yup.object().shape({
  profile: yup.string().when("typeId", {
    is: '3', then: yup.string().required('Please Select a Product Distributor Profile')
  }),
  speciality: yup.string().when("typeId", { is: '3', then: yup.string().when("profile", { is: "1", then: yup.string().required('Please Select Channel Speciality') }) }),

  relevantChannelProfiles: yup.string().when("typeId", { is: (typeId) => (typeId == '2' || typeId == '3'), then: yup.string().required('Please Select Channel Profile') }),

  relevantRetailerProfiles: yup.object().when("typeId", {
    is: '4', then: yup.object().shape({
      // firstLetter: yup.string().required(),
      //groupid: yup.string().required(),
      groupname: yup.string().required(),
      // childid: yup.string().required(),
      childname: yup.string().required(),

    }).required('Please Select Channel Profile')
  }),

  brandList: yup.string().when("typeId", { is: (typeId) => (typeId == '2' || typeId == '3'), then: yup.string().required('Please Choose a Brand') }),

  productCat: yup.string().required('Please Select a Product Family'),
});

const factProfileSchema = yup.object().shape({
  Yearestablishment: yup.number().required('Please Enter Year').min(1830, 'Year Must be minimum 1830 ').max(currentYear, `year Must be less than or equal to ${currentYear}`).typeError('Please Enter Year'),
  no_of_skus: yup.number().when("typeId", { is: '2', then: yup.number().required('Please Enter No of SKUs').min(0, 'Sku must have min 0').max(9999, 'sku must have max 4 digits').typeError("Please Enter No of SKUs") }).nullable(),
  storeCount: yup.number().when("typeId", { is: '4', then: yup.number().required("Please Enter No of Store's").min(0, 'No of store must have min 0').max(9999, 'sku must have max 4 digits').typeError("Please Enter No of Store's") }).nullable(),
  no_of_staffs: yup.string().required('Select No.of.Staffs'),
  annualTurnOver: yup.string().required('Select Annual Turnover'),
  startUpType: yup.string().when('areYouStartUp', { is: '1', then: yup.string().required('Please Choose Maturity Level') }),
});

const retailProfileSchema = yup.object().shape({
  Yearestablishment: yup.number().required('Please Enter Year').min(1830, 'Year Must be minimum 1830 ').max(currentYear, `year Must be less than or equal to ${currentYear}`).typeError('Please Enter Year'),
  companyLogo: yup.string().required('Please Select companyLogo'),
  companyName: yup.string().required('Please Enter Company Legal Name'),
  country: yup.string().required('Please Select Your country'),
 // metaTags: yup.string().required('Please Enter Company Meta Tags').matches(/^[a-zA-Z,]+$/, 'Meta Tags allows Only alphabets (both uppercase and lowercase) and commas'),
  customUrl: yup.string().required('Please Enter Custom URL').matches(/^[a-zA-Z0-9_ ]+$/, 'Custom URL  allows Only alphabets (both uppercase and lowercase),space , underscore'), 
  zipCode: yup.string().required('Please Enter Zip/Postal Code').min(3, 'Zip/Postal Code Must Have Min 3 Characters').max(12, 'Zip/Postal Code Must Have Max 12 Characters'),
  tweetPitch: yup.string().required("TweetPitch can't be empty!").min(5, 'TweetPitch must have min 5 Characters').max(280, 'TweetPitch must have max 280 Characters'),
  // sourcing: yup.string().min(5, 'Sourcing Priority & Strategy must have min 5 Characters').max(2000, 'Sourcing Priority & Strategy must have max 2000 Characters'),
  companyDesc: yup.string().min(5, 'Company Description must have min 5 Characters').max(2000, 'Company Description must have max 2000 Characters'),
  CRN: yup.string().required('Please Enter Company Registration Number').
    min(3, 'Company Registration number must have minimum 3 characters.').max(70, 'Company Registration number must have maximum 70 Characters.'), //matches(/^[a-z0-9]+$/i, 'only Alphanumeric characters are allowed.').
  // VATN : yup.string().matches(/^$|^[a-zA-Z0-9]+$/i, 'only Alphanumeric characters are allowed.').max(70, 'Company Registration number must have maximum 70 Characters.').nullable(),
  VATN: yup.string().when(
    "isVat", {
    is: '1',
    then: yup.lazy(value => !value ? yup.string() : yup.string().min(3, 'VAT number must have minimum 3 characters.').
      matches(/^[a-z0-9]+$/i, 'only Alphanumeric characters are allowed.').max(70, 'VAT number must have maximum 70 Characters.')),
    //  yup.string().required('Please Enter VAT Number').min(3, 'VAT number must have minimum 3 characters.').
    // matches(/^[a-z0-9]+$/i, 'only Alphanumeric characters are allowed.').max(70, 'Company Registration number must have maximum 70 Characters.'),
  }
  ),
  city: yup.string().required('Please Enter Your City.'),
  phoneNumber1: yup.string()
  .test('max-length', 'The maximum length for the field is 30 characters.', function(value) {
    // Check if the value is not empty and its length exceeds 30 characters
    return !(value && value.length > 30);
  })
  .test('min-length', 'Phone number must have minimum 5 characters.', function(value) {
    // Check if the value is not empty and its length is less than 5 characters
    return !(value && value.length > 0 && value.length < 5);
  })
  .test('valid-phone', 'Please Enter a valid Phone Number', function(value) {
    // Check if the value is not empty
    if (value && value.length > 0) {
      // Validate phone number pattern
      const isValidPattern = /^(?!(.*\s){4,})[0-9+ -]*[0-9]+[0-9+ -]*$/.test(value) &&
        /^(?:(?!([0-9])\1{5,}).)*$/.test(value);
      // Validate presence of non-special characters
      const hasNonSpecialChar = !/^[!@#$%^&*()_{}\[\]:;<>,.?~\\|\="']*$/.test(value);
      // Return true if both conditions are met
      return isValidPattern && hasNonSpecialChar;
    }
    // If value is empty or null, no custom validation needed
    return true;
  })
  .nullable(), // Allows phoneNumber1 to be empty or null without validation
   mobile: yup.string().min(5, 'Phone number must have minimum 5 characters.').max(30, 'Phone number must have maximum 30 Characters.').transform(value => !value ? null : value).nullable(),
  email: yup.string().email('Please Enter a valid Email Address').transform(value => !value ? null : value).nullable(),

  tradeUrls: yup.array().of(yup.object({
    value: yup.lazy(value => !value ? yup.string() : yup.string()
      .matches(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,63}(:[0-9]{1,63})?(\/.*)?$/, 'Please Enter Valid Url.'))
  })),

  insta: yup.lazy(value => !value ? yup.string() : yup.string().min(2, 'Instagram handle should have more than 2 characters').max(30, 'Instagram handle should have maximum of 30 characters')),
  // matches(/^(?=[a-zA-Z0-9._-]{0,30}$)(?!.*[_.-]{2})[^_.-].*[^_.-]$/, 'Please Enter Valid Instagram Handle')),
  // .matches(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/, 'Please Enter Valid Url.')),
  twitter: yup.lazy(value => !value ? yup.string() : yup.string().min(2, 'X handle should have more than 2 characters').max(15, 'X handle should have maximum of 15 characters')),
  // matches(/^(?=[a-zA-Z0-9._-]{0,15}$)(?!.*[_.-]{2})[^_.-].*[^_.-]$/, 'Please Enter Valid Twitter Handle')),
  // .matches(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/, 'Please Enter Valid Url.')),
  facebook: yup.lazy(value => !value ? yup.string() : yup.string().min(2, 'Facebook handle should have more than 2 characters').max(50, 'Facebook handle should have maximum of 50 characters')),
  // matches(/^(?=[a-zA-Z0-9._-]{0,50}$)(?!.*[_.-]{2})[^_.-].*[^_.-]$/, 'Please Enter Valid Facebook Handle')),
  // .matches(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/, 'Please Enter Valid Url.')),
  linkedIn: yup.lazy(value => !value ? yup.string() : yup.string().min(2, 'LinkedIn handle should have more than 2 characters').max(100, 'LinkedIn handle should have maximum of 100 characters')),
  // matches(/^(?=[a-zA-Z0-9._-]{0,100}$)(?!.*[_.-]{2})[^_.-].*[^_.-]$/, 'Please Enter Valid LinkedIn Handle')),


  productCat: yup.string().required('Please Select a Product Family'),

  // storeCount: yup.number().required("Please Enter No of Store's").min(0, 'No of store must have min 0').max(9999, 'sku must have max 4 digits').typeError("Please Enter No of Store's").nullable(),

  no_of_staffs: yup.string().required('Select No.of.Staffs'),
  annualTurnOver: yup.string().required('Select Annual Turnover'),
  turnOver: yup.lazy(value => !value ? yup.string() : yup.number().min(0, 'Please enter non-negative values')),
  staffCnt: yup.lazy(value => !value ? yup.string() : yup.number().min(0, 'Please enter non-negative values')),

  relevantRetailerProfiles: yup.object().shape({
    groupname: yup.string().required(),
    childname: yup.string().required(),

  }).required('Please Select Channel Profile'),
  startup: yup.string(),
  productBrand: yup.string().when("startup", { is: '1', then: yup.string().required('select maturity level') }),
  websiteUrl: yup.string().required('Please Enter Company Website URL').matches(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,63}(:[0-9]{1,63})?(\/.*)?$/, 'Please Enter Valid Url.'),

  selling: yup.string().when("typeId", { is: (typeId) => (typeId == 4 || typeId == 3 || typeId == 5), then: yup.string().required('Please Choose Selling Locations') }),

});

const YourChannelSchema = yup.object().shape({

  // profile: yup.string().when("typeId",{is:'3',then:yup.string().required('Please Select a Product Distributor Profile')
  //     }),
  // speciality: yup.string().when("typeId", {is:'3', then: yup.string().when("profile", {is: "1", then: yup.string().required('Please Select Channel Speciality')})}),
  // Brands:yup.object().when("typeId", {is: (typeId) => (typeId==2 || typeId==3 ),
  //     then:yup.object().shape({
  //     id: yup.number(),
  //     name: yup.string().required(),
  //     doc_id: yup.string(),
  //     documentpath: yup.string(),
  //     isNew: yup.string(),
  //   }).required('Choose a Brand').nullable()
  // }),

  //   Retailers:yup.object().when("startUpType", {is: (typeId) => (typeId=='S_VOLUME'),
  //     then:yup.object().shape({
  //     id: yup.number(),
  //     name: yup.string().required(),
  //     doc_id: yup.string(),
  //     documentpath: yup.string(),
  //     isNew: yup.string(),
  //   }).required('Choose a Brand').nullable()
  // }),

  // Distributor:yup.object().when("startUpType", {is: (typeId) => (typeId=='S_VOLUME'),
  //   then:yup.object().shape({
  //   id: yup.number(),
  //   name: yup.string().required(),
  //   doc_id: yup.string(),
  //   documentpath: yup.string(),
  //   isNew: yup.string(),
  // }).required('Choose Key Distributor').nullable()
  // }),
  // brandList: yup.string().when("typeId", {is: (typeId) => (typeId=='2' || typeId=='3'), then: yup.string().required('Please Choose a Brand')}),
  // retailerList:  yup.string().when("startUpType", {is: (typeId) => (typeId=='S_VOLUME'),then:yup.string().required('Please Choose a Retailer')})
  // .when("typeId", {is: '3', then: yup.string().required('select a retailer (typeId3)')}),
  // DistributorList:  yup.string().when("startUpType", {is: (typeId) => (typeId=='S_VOLUME'),then:yup.string().required('Please Choose a Distributor')}),


  // relevantChannelProfiles:yup.string().when("typeId", {is: (typeId) => (typeId=='2' || typeId=='3'),then: yup.string().required('Please Select Channel Profile')}),
  // productCat:yup.string().required('Please Select a Product Family'),

  // DistributorProfiles:yup.object().when("typeId",{is:'2',then:yup.object().shape({
  //     firstLetter: yup.string().required(),
  //     //groupid: yup.string().required(),
  //     groupname: yup.string().required(),
  //     childid: yup.string().required(),
  //     childname: yup.string().required(),
  //   }).required('Please Select Distributor Profile')
  // }),

  // relevantRetailerProfiles:yup.object().when("typeId",{is:'4',then:yup.object().shape({
  //   // firstLetter: yup.string().required(),
  //   //groupid: yup.string().required(),
  //   groupname: yup.string().required(),
  //   // childid: yup.string().required(),
  //   childname: yup.string().required(),

  // }).required('Please Select Channel Profile')}),

  // startUpType: yup.string().when('areYouStartUp', {is:'1', then:yup.string().required('Please Choose Maturity Level')}),
  // no_of_staffs: yup.string().required('Select No.of.Staffs'),
  // annualTurnOver: yup.string().required('Select Annual Turnover'),

  // no_of_skus: yup.number().when("typeId",{is:'2', then:yup.number().required('Please Enter No of SKUs').min(0, 'Sku must have min 0').max(9999, 'sku must have max 4 digits').typeError("Please Enter No of SKUs")}),
  // storeCount: yup.number().when("typeId",{is:'4', then:yup.number().required("Please Enter No of Store's").min(0, 'No of store must have min 0').max(9999, 'sku must have max 4 digits').typeError("Please Enter No of Store's")}),

  no_of_retailers: yup.number().when("businessType", { is: (typeId) => (typeId == '1' || typeId == '3'), then: yup.number().required('Please Enter No of Retailers').min(0, 'Retailer must have min 0').typeError('Please Enter No of Retailers') }),
  no_of_distributors: yup.number().required('Please Enter No of Distributors').min(0, 'Distributor must have min 0').typeError('Please Enter No of Distributors'),
  no_of_resellers: yup.number().when("businessType", { is: (typeId) => (typeId == '2' || typeId == '3'), then: yup.number().required('Please Enter No of Resellers').min(0, 'Reseller must have min 0').typeError('Please Enter No of Resellers') }),
  // revenue: yup.number().max(100, 'The total of Domestic Revenue and International Revenue should not exceed 100%').nullable(),
  relevantChannelProfiles: yup.string().when("businessType", { is: (typeId) => (typeId == '1' || typeId == '3'), then: yup.string().required('Please Select Retailer Profile') }),
  relevantResellerProfiles: yup.string().when("businessType", { is: (typeId) => (typeId == '2' || typeId == '3'), then: yup.string().required('Please Select Reseller Profile') }),
  startUpType: yup.string().when('areYouStartUp', { is: '1', then: yup.string().required('Please Choose Maturity Level') }),

});

const updateContact = yup.object().shape({
  firstName: yup.string().required('Please Enter First Name').min(2, 'First Name Must Have Min 2 Characters').max(30, 'First Name Must Have Max 30 Characters'),
  lastName: yup.string().required('Please Enter Last Name').max(30, 'Last Name Must Have Max 30 Characters'),
  mobile: yup.string().required('Please Enter Mobile Number.').min(5, 'Mobile number must have minimum 5 characters.').max(30, 'Mobile number must have maximum 30 Characters.'), //matches(/^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,'Please Enter Valid Mobile Number').
  phone: yup.lazy(value => !value ? yup.string() : yup.string().required('Please Enter Mobile Number.').min(5, 'Mobile number must have minimum 5 characters.').max(30, 'Mobile number must have maximum 30 Characters.')),//matches(/^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{1,4}?$/,'Please Enter Valid Phone Number').
  email: yup.string().required('Please Enter Email Address').email('Please Enter a valid Email Address'),
  country: yup.string().required('Please Select Your country'),
  jobposition: yup.string().required('Please Enter Job Position').min(2, 'Job Position Must Have Min 2 Characters'),
  contactHubspotId: yup.string().required('Please Enter Contact Hubspot Id.').min(3, 'Contact Hubspot Id must have minimum 5 characters.'),
  // reportingTo: yup.string().when("roleId", {is: (roleId) => (roleId!=1), then:yup.string().required('Please Select Reporting Id') }),
});

const boUser = ({ role }) => yup.object().shape({
  firstName: yup.string().required('Please Enter First Name').min(2, 'First Name Must Have Min 2 Characters').max(30, 'First Name Must Have Max 30 Characters'),
  lastName: yup.string().required('Please Enter Last Name').max(30, 'Last Name Must Have Max 30 Characters'),
  role: yup.string().required('Select User Role'),
  email: yup.string().required('Enter Valid Email Address'),
  managedChannelType: (role == 2 || role == 4) ? yup.string().required() : '',
  managedCountry: (role == 2 || role == 4) ? yup.string().required() : ''
});


const otherUserSchema = yup.object().shape({
//  channelType: yup.string().required('Please Select Channel Type'),
  firstname: yup.string().required('Please Enter FirstName.'),
  lastname: yup.string().required('Please Enter LastName.'),
  jobposition: yup.string().required('Please Enter Job Title.'),
  // // password: yup.string().required('Please Enter Password.'),
  // // confirm_password: yup.string().required('Please Enter Confirm password.'),
  mobile: yup.string().required('Please Enter Mobile Number .').min(5, 'Phone number must have minimum 5 characters.').transform(value => !value ? null : value).nullable(),
  emailId: yup.string().required('Please Enter Email Id.').email('Please Enter a valid Email Address').transform(value => !value ? null : value).nullable(),

   yearOfEstablishment: yup.number().required('Please Enter Year').min(1830, 'Year Must be minimum 1830 ').max(currentYear, `year Must be less than or equal to ${currentYear}`).typeError('Please Enter Year'),
   companyLogo: yup.string().required('Please Select companyLogo'),
   companyName: yup.string().required('Please Enter Company Legal Name'),
  // metaTags: yup.string().required('Please Enter Company Meta Tags').matches(/^[a-zA-Z,]+$/, 'Meta Tags allows Only alphabets (both uppercase and lowercase) and commas'),
  customUrl: yup.string().required('Please Enter Custom URL').matches(/^[a-zA-Z0-9_ ]+$/, 'Custom URL  allows Only alphabets (both uppercase and lowercase) ,Space, underscore'),  
   country: yup.string().required('Please Select Your country'),
   zipCode: yup.string().required('Please Enter Zip/Postal Code').min(3, 'Zip/Postal Code Must Have Min 3 Characters').max(12, 'Zip/Postal Code Must Have Max 12 Characters'),
   websiteUrl: yup.string().required('Please Enter Company Website URL').matches(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,63}(:[0-9]{1,63})?(\/.*)?$/, 'Please Enter Valid Url.'),
   tweetPitch: yup.string().required("TweetPitch can't be empty!").min(5, 'TweetPitch must have min 5 Characters').max(280, 'TweetPitch must have max 280 Characters'),
  // sourcing: yup.string().when("typeId", { is: (typeId) => (typeId != '2'), then: yup.string().min(5, 'Sourcing Priority & Strategy must have min 5 Characters').max(5000, 'Sourcing Priority & Strategy must have max 5000 Characters') }),
  //companyDesc: yup.string().min(5, 'Company Description must have min 5 Characters').max(2000, 'Company Description must have max 2000 Characters'),
  // CRN: yup.string().required('Please Enter Company Registration Number').
  //   min(3, 'Company Registration number must have minimum 3 characters.').max(70, 'Company Registration number must have maximum 70 Characters.'), //matches(/^[a-z0-9]+$/i, 'only Alphanumeric characters are allowed.').
  // VATN : yup.string().matches(/^$|^[a-zA-Z0-9]+$/i, 'only Alphanumeric characters are allowed.').max(70, 'Company Registration number must have maximum 70 Characters.').nullable(),
  // VATN: yup.string().when(
  //   "isVat", {
  //   is: '1',
  //   then: yup.string().required('Please Enter VAT Number').min(3, 'VAT number must have minimum 3 characters.').
  //     matches(/^[a-z0-9]+$/i, 'only Alphanumeric characters are allowed.').max(70, 'Company Registration number must have maximum 70 Characters.'),
  // }
  // ),
  // city: yup.string().required('Please Enter City.'),
  // phoneNumber1: yup.string()
  // .test('max-length', 'The maximum length for the field is 30 characters.', function(value) {
  //   // Check if the value is not empty and its length exceeds 30 characters
  //   return !(value && value.length > 30);
  // })
  // .test('min-length', 'Phone number must have minimum 5 characters.', function(value) {
  //   // Check if the value is not empty and its length is less than 5 characters
  //   return !(value && value.length > 0 && value.length < 5);
  // })
  // .test('valid-phone', 'Please Enter a valid Phone Number', function(value) {
  //   // Check if the value is not empty
  //   if (value && value.length > 0) {
  //     // Validate phone number pattern
  //     const isValidPattern = /^(?!(.*\s){4,})[0-9+ -]*[0-9]+[0-9+ -]*$/.test(value) &&
  //       /^(?:(?!([0-9])\1{5,}).)*$/.test(value);
  //     // Validate presence of non-special characters
  //     const hasNonSpecialChar = !/^[!@#$%^&*()_{}\[\]:;<>,.?~\\|\="']*$/.test(value);
  //     // Return true if both conditions are met
  //     return isValidPattern && hasNonSpecialChar;
  //   }
  //   // If value is empty or null, no custom validation needed
  //   return true;
  // })
  // .nullable(),
  //.number().
  // phoneNumber2:yup.string().min(5,'Phone number must have minimum 5 characters.').max(30,'Phone number must have maximum 30 Characters.').transform(value => !value ? null : value).nullable(), 



  insta: yup.lazy(value => !value ? yup.string() : yup.string().min(2, 'Instagram handle should have more than 2 characters').max(30, 'Instagram handle should have maximum of 30 characters')),
  // matches(/^(?=[a-zA-Z0-9._-]{0,30}$)(?!.*[_.-]{2})[^_.-].*[^_.-]$/, 'Please Enter Valid Instagram Handle')),
  // .matches(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/, 'Please Enter Valid Url.')),
  twitter: yup.lazy(value => !value ? yup.string() : yup.string().min(2, 'X handle should have more than 2 characters').max(15, 'X handle should have maximum of 15 characters')),
  // matches(/^(?=[a-zA-Z0-9._-]{0,15}$)(?!.*[_.-]{2})[^_.-].*[^_.-]$/, 'Please Enter Valid Twitter Handle')),
  // .matches(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/, 'Please Enter Valid Url.')),
  facebook: yup.lazy(value => !value ? yup.string() : yup.string().min(2, 'Facebook handle should have more than 2 characters').max(50, 'Facebook handle should have maximum of 50 characters')),
  // matches(/^(?=[a-zA-Z0-9._-]{0,50}$)(?!.*[_.-]{2})[^_.-].*[^_.-]$/, 'Please Enter Valid Facebook Handle')),
  // .matches(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/, 'Please Enter Valid Url.')),
  linkedIn: yup.lazy(value => !value ? yup.string() : yup.string().min(2, 'LinkedIn handle should have more than 2 characters').max(100, 'LinkedIn handle should have maximum of 100 characters')),
  // matches(/^(?=[a-zA-Z0-9._-]{0,100}$)(?!.*[_.-]{2})[^_.-].*[^_.-]$/, 'Please Enter Valid LinkedIn Handle')),

  // tradeUrls: yup.array().of(yup.object({
  //   value: yup.lazy(value => !value ? yup.string() : yup.string()
  //     .matches(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,63}(:[0-9]{1,63})?(\/.*)?$/, 'Please Enter Valid Url.'))
  // })),

  // brandList: yup.string().when("typeId", { is: (typeId) => (typeId == '2' || typeId == '3'), then: yup.string().required('Please Choose a Brand') }),



  // productCat: yup.string().required('Please Select a Product Family'),

   no_of_skus: yup.number().when("typeId", { is: '2', then: yup.number().required('Please Enter No of SKUs').min(0, 'Sku must have min 0').max(9999, 'sku must have max 4 digits').typeError("Please Enter No of SKUs") }).nullable(),
  // storeCount: yup.number().when("typeId",{is:'4', then:yup.number().required("Please Enter No of Store's").min(0, 'No of store must have min 0').max(9999, 'sku must have max 4 digits').typeError("Please Enter No of Store's")}).nullable(),

  // revenue: yup.number().max(100, 'The total of Domestic Revenue and International Revenue should not exceed 100%').nullable(),

  // no_of_staffs: yup.string().required('Select No.of.Staffs'),
  // annualTurnOver: yup.string().required('Select Annual Turnover'),
  // turnOver: yup.lazy(value => !value ? yup.string() : yup.number().min(0, 'Please enter non-negative values')),
  // staffCnt: yup.lazy(value => !value ? yup.string() : yup.number().min(0, 'Please enter non-negative values')),

  // password: yup
  //   .string()
  //   .required('Please enter your password').min(8, 'Password Must Have Min 8 Characters').max(25, 'Password Must Have Max 25 Characters')
  //   .matches(
  //     /^((?=.*[#?!@$%^&*-]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/,
  //     'Password must contain at least one uppercase, one lowercase, one number and one special case character'
  //   ).matches(/^[ A-Za-z0-9#?!@$%^&*-]*$/, 'Password can only contain the following special characters #?!@$%^&*-'),
  //   confirm_password: yup.string().required('Confirm password is required').oneOf([yup.ref('password'), null], 'Passwords must match.')

});

const couponFormSchema = yup.object().shape({
  couponDesc: yup.string().required('Please Enter Coupon Description').min(2, 'Coupon Description Must Have Min 2 Characters'),
  couponOfferValue: yup.number().required('Please Enter Coupon Offer Value'),
  discountValue: yup.string().required('Please Enter Coupon Discount Unit'),
  couponCode: yup.string().required('Please Enter Coupon Code'),
  // datefrom: yup.date().required('Please Enter Coupon From Date'),
  // dateto: yup.date().required('Please Enter Coupon To Date'),
  statusValue: yup.string().required('Please Enter Coupon Active/Inactive'),
  subTypeValue: yup.string().required('Please Enter Coupon subscription Type'),
  typeValue: yup.string().required('Please Enter Coupon Channel Type'),
  planValue: yup.string().required('Please Enter Please Select Subscription Plan'),
  userThreshold: yup.string().required('Please Enter User Threshold'),
  usageThreshold: yup.string().required('Please Enter Usage Threshold'),
  periodValue: yup.string().required('Please Enter Coupon Subscription Period'),
});


const NewAddProductSchema = yup.object().shape({
  proname: yup.string().required('Enter Product Name').min(3, 'Product Name must have Min 3 Characters').max(255, 'Product Name must have Max 255 Characters'),
  
  ProductCategory: yup.object().shape({
    id: yup.number().required(),
    name: yup.string().required(),
    groupid: yup.string().required(),
  }).required('Choose Product Category').nullable(),
  ProductBrand: yup.object().shape({
    id: yup.number().required(),
    name: yup.string().required()
  }).required('Choose Product Brand').nullable(),
  productUrl: yup.string().required('Enter Product URL').matches(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/, 'Add the url of the product on your web site or any url where you have a full description of the product.').transform(value => !value ? null : value).nullable().max( 255, 'Product url should not exceed 255 characters' ),

});

// reportingTo: yup.string().when("roleId", {is: (roleId) => (roleId!=1), then:yup.string().required('Please Select Reporting Id') }),


export { InitialprofileSchema, AddFirstProductSchema, UserProfileSchema, companyProfileSchema, TradeInformationSchema, TradeLocationSchema, AddProductSchema, ProductTradeDetailsSchema, PostYourBuyingNeed, companyProfileBasiEditSchema, profileEditSchema, factProfileSchema, companyDistProfileSchema, retailProfileSchema, YourChannelSchema, updateContact, boUser, otherUserSchema, couponFormSchema, NewAddProductSchema };
